module.exports = __webpack_public_path__ + "img/logo-bg.3dc7e56c.png";